// api接口前缀
const apiBaseUrl = {
    baseUrl1: 'http://122.114.22.138:12001', // 园区，仓储，资讯
    baseUrl2: 'http://122.114.22.138:12000', // 字典,登录
    baseUrl3: 'http://122.114.22.138:12002', // 货源
    // 生产环境
    // baseUrl1: 'http://192.168.1.138:12001', //园区，仓储，资讯
    // baseUrl2: 'http://192.168.1.138:12000', //字典,登录
    // baseUrl3: "http://192.168.1.138:12002", //货源
    // 测试站
    // baseUrl1: 'http://172.16.1.202:12001', //园区，仓储，资讯
    // baseUrl2: 'http://172.16.1.202:12000', //字典,登录
    // baseUrl3: "http://172.16.1.202:12002", //货源
    // 本地
    // baseUrl1: 'http://10.1.12.34:9998', //园区，仓储，资讯
    // baseUrl2: 'http://10.1.12.34:9999', //字典,登录
    // baseUrl3: "http://10.1.12.34:9996", //货源
    baseUrl4: 'http://wl.hhzp086.com', // 招聘
    baseUrl5: 'http://www.ywb56.com' // 货源抢单跳转链物流
        // baseUrl5: "http://www.testywb56.com/", //货源抢单跳转链物流测试站
}
const nodeCity = {
    Platform: '0315', // 不区分区县
    resourcePlatform: '',
    nodeType: '4',
    name: '唐山'
}
export default {
    apiBaseUrl,
    nodeCity
}


// WEBPACK FOOTER //
// ./src/assets/config.js